import { useInjection } from 'inversify-react';
import { INVERSIFY_TYPES } from '@edikk-edikk/ui';
import { Feature } from '#components/feature';

const useFeature = () => useInjection<Feature>(INVERSIFY_TYPES.feature);

export { useFeature };
